export default __webpack_public_path__ + "static/media/feat-airdrop.cd0f2f14.svg";